<template>
  <b-container style="padding-bottom: 0px">
    <b-row class="mb-5">
      <b-col align="center ">
        <h5>강의 방식</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        class="mb-5"
        cols="6"
        v-for="feature in currentfeatures"
        :key="feature.title"
      >
        <b-row>
          <b-col md="6">
            <b-img no-gutters :src="feature.image"></b-img>
          </b-col>
          <b-col md="6">
            <p>{{ feature.title }}</p>
            <p v-html="feature.description"></p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      features: {},
      currentfeatures: {}
    };
  },
  created() {
    this.features = [
      {
        id: 0,
        data: [
          {
            image: require("@/assets/images/curriculumImages/21C.png"),
            title: "21세기 기술",
            description: "비영리 국제 교육기구인 바텔에서 정의한 \n 학생이 가져야 하는 21세기 필수 기술인 디지털 리터러시, \n 비판적 사고등을 함양하는 과정입니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/dd_2.jpg"),
            title: "플립드 러닝",
            description: "프로그래밍과 관련된 기초 지식은 \n 온라인 교육 과정을 통해 습득 하고, 강의 실에서는 학생 상호 학습을 합니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/dd_3.jpg"),
            title: "게이미피케이션",
            description: "교육 과정을 통해 얻은 지식을 \n 친구들과 나누는 지식장터, 팀빌딩 및 아이디어 공유를 위한 포스터 세션등을 게임화해서 교육과정에 녹여내고 있습니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/dd_4.jpg"),
            title: "UX디자인",
            description: "코딩에 앞서 UX를 학습하여 사용성에 대한 고민을 먼저 합니다. 이런 경험을 통해 개발팀내의 디자이너, 기획자등과 원활한 커뮤니케이션 기술을 익힐 수 있습니다."
              .split("\n")
              .join("<br/>")
          }
        ]
      },
      {
        id: 1,
        data: [
          {
            image: require("@/assets/images/curriculumImages/21C.png"),
            title: "21세기 기술",
            description: "비영리 국제 교육기구인 바텔에서 정의한 \n 학생이 가져야 하는 21세기 필수 기술인 디지털 리터러시, \n 비판적 사고등을 함양하는 과정입니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/lc_2.jpg"),
            title: "플레이 그라운드 코딩 컨텐츠",
            description: "Swift 언어를 iPad Playground \n 코딩배우기를 통해 학습하게 되며, \n 실제 개발에 사용되는 언어로 쉽고 \n 재미있게 Swift 언어 기초를 \n 다질 수 있습니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/codin.jpg"),
            title: "게이미피케이션",
            description: "학습을 운영에\n 게이미피케이션을 적용하여, 교육과정에 몰입하는데 \n  도움을 받습니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/lc_4.jpg"),
            title: "언플러그드 활동",
            description: "코딩에 익숙하지 않은 학습자들이 \n 친숙하게 느끼는 일상사물들을 교보재로 활용해 프로그래밍의 \n 개념을 익힙니다. "
              .split("\n")
              .join("<br/>")
          }
        ]
      },
      {
        id: 2,
        data: [
          {
            image: require("@/assets/images/curriculumImages/21C.png"),
            title: "21세기 기술",
            description: "21세기에 학생들이 가져야 하는 필수 기술인 디지털 리터러시, \n 비판적 사고등을 함양하는 과정입니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/ux_2.jpg"),
            title: "프로젝트 기반 학습",
            description: "학습자들은 직접 자신의 아이디어를 정리하고 도구를 익히게 되며, 팀단위 학습을 통해 소통과 문제해결의 전과정을 경험하게 됩니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/dd_3.jpg"),
            title: "디자인 씽킹",
            description: "디자인 씽킹을 통해 사용자에 대한 이해, 문제 정의, 아이디어를 구체화 하는 과정을 통해서 앱개발을 하게 됩니다."
              .split("\n")
              .join("<br/>")
          },
          {
            image: require("@/assets/images/curriculumImages/ux_4.png"),
            title: "애플의 앱다자인 싸이클",
            description: "디자인 씽킹을 통해 사용자에 대한 이해, 문제 정의, 아이디어를 구체화 하는 과정을 통해서 앱개발을 하게 됩니다."
              .split("\n")
              .join("<br/>")
          }
        ]
      }
    ];
    this.currentfeatures = this.features.filter(e => e.id === this.id)[0].data;
  }
};
</script>

<style scoped>
.card-title {
  font-size: 1.4em;
}
img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
